import React, { Component } from "react";
import axios from "axios";
import constants from "../../constants";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel/index";
import { ToastContainer, toast } from "react-toastify";

import pur from "json-prune";
import { Link } from "react-router";

class PaymentSolicitation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableData: [],
      searchResult: null,
    };

    this.setFilter = this.setFilter.bind(this);
    this.erasePaymentSolicitation = this.erasePaymentSolicitation.bind(this);
  }

  setFilter(e) {
    if (e.target.value.length > 0) {
      let result = this.dataFilter(this.state.tableData, e.target.value);
      this.setState({ searchResult: result });
    } else {
      this.setState({ searchResult: null });
    }
  }
  dataFilter(data, value) {
    let searched = value.toLowerCase();
    let result = [];
    data.forEach((dataItem) => {
      Object.keys(dataItem).some((key) => {
        let valueString = JSON.stringify(dataItem[key]).toLowerCase();
        if (valueString.includes(searched)) {
          result = result.concat(dataItem);
          return true;
        }
      });
    });

    return result;
  }

  filterData(data, filter) {
    return data.filter((item) => {
      return Object.keys(item).some((key) =>
        item[key].toLowerCase().includes(filter.toLowerCase())
      );
    });
  }

  componentDidMount() {
    this.getPaymentSolicitation();
    // setInterval(() => {
    //   if(localStorage.token){
    //     this.getPaymentSolicitation();
    //   }else{
    //     console.error("Sem Autorização")
    //   }

    // }, 5000);
  }

  getPaymentSolicitation() {
    const url =
      constants().URL_SERVICE +
      "establishment/paymentrequest/list_payment_requests/";

    axios
      .get(url, { headers: { Authorization: "Token " + localStorage.token } })
      .then((response) => {
        this.setState({ tableData: response.data.list });
      })
      .catch((error) => this.setState({ error: true }));
  }

  erasePaymentSolicitation(id) {
    const url =
      constants().URL_SERVICE +
      "establishment/paymentrequest/delete_payment_request/";

    axios
      .post(
        url,
        { id: id },
        { headers: { Authorization: "Token " + localStorage.token } }
      )
      .then((response) => {

        toast.success("Pagamento excluído com sucesso", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.getPaymentSolicitation()
        // this.setState({ tableData: response.data.list });
      })
      .catch((error) => {
        this.setState({ error: true });
        toast.error("Ocorreu um Erro Durante o Cancelamento", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  }
  cancelPaymentSolicitation(id) {
    const url =
      constants().URL_SERVICE + "establishment/paymentrequest/cancel_payment/";

    axios
      .post(
        url,
        { id: id },
        { headers: { Authorization: "Token " + localStorage.token } }
      )
      .then((response) => {
        toast.success("Pagamento Cancelado com sucesso", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.getPaymentSolicitation()
        // this.setState({ tableData: response.data.list });
      })
      .catch((error) =>
        toast.error("Ocorreu um Erro Durante o Cancelamento", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      );
  }

  render() {
    const data = this.state.tableData;
    const filter = this.state.filter;
    const tableData = !filter ? data : this.filterData(data, filter);

    return (
      <div>
        <BarTitle name="Solicitações" />
        <div className="wrapper-md">
          <Painel title="Clientes">
            <div className="row">
              <div className="col-md-4">
                <div className="input-group panel">
                  <span className="input-group-addon" id="filter-addon">
                    Buscar
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    aria-describedby="filter-addon"
                    onChange={this.setFilter}
                  />
                </div>
              </div>
              <div className="col-md-1">
                <Link
                  type="button"
                  className="btn btn-info"
                  to={{
                    pathname: "home/users/",
                  }}
                >
                  Nova Solicitação de pagamento
                </Link>
              </div>
            </div>
            <div className="table-wrap">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Descrição</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.searchResult
                    ? this.state.searchResult.map((solicition, i) => (
                        <tr>
                          <td> {solicition.id} </td>
                          <td>
                            <b>Nome: </b>
                            {solicition.client.name}
                            <br />
                            <b>CPF: </b>
                            {solicition.client.cpf}
                            <br />
                            <b>Email: </b>
                            {solicition.client.email}
                            <br />
                            <b>Telefone: </b>
                            {solicition.client.phone}
                          </td>
                          <td style={{ width: "600px" }}>
                            <b>Valor: </b>
                            {solicition.price}
                            <br />
                            <b>Data e hora: </b>
                            {solicition.date} - {solicition.time}
                            <br />
                            <b>Descrição: </b>
                            {solicition.description}
                          </td>

                          <td>
                            {solicition.status == 0 ? (
                              <label className="label bg-warning m-l-xs">
                                Pendente
                              </label>
                            ) : null}

                            {solicition.status == 1 ? (
                              <label className="label bg-success m-l-xs">
                                Aprovado
                              </label>
                            ) : null}

                            {solicition.status == 2 ? (
                              <label className="label bg-danger m-l-xs">
                                Recusado
                              </label>
                            ) : null}
                            {solicition.status == 3 ? (
                              <label className="label bg-danger m-l-xs">
                                {solicition.status_title}
                              </label>
                            ) : null}
                          </td>
                          <td>
                            <button
                              onClick={() =>
                                this.cancelPaymentSolicitation(solicition.id)
                              }
                              className="btn btn-danger"
                            >
                              Cancelar Solicitação de Pagamento
                            </button>
                            <button
                              onClick={() =>
                                this.erasePaymentSolicitation(solicition.id)
                              }
                              style={{ marginTop: 5 }}
                              className="btn btn-danger "
                            >
                              Excluir Solicitação de Pagamento
                            </button>
                          </td>
                        </tr>
                      ))
                    : this.state.tableData.map((solicition, i) => (
                        <tr>
                          <td> {solicition.id} </td>
                          <td>
                            <b>Nome: </b>
                            {solicition.client.name}
                            <br />
                            <b>CPF: </b>
                            {solicition.client.cpf}
                            <br />
                            <b>Email: </b>
                            {solicition.client.email}
                            <br />
                            <b>Telefone: </b>
                            {solicition.client.phone}
                          </td>
                          <td style={{ width: "600px" }}>
                            <b>Valor: </b>
                            {solicition.price}
                            <br />
                            <b>Data e hora: </b>
                            {solicition.date} - {solicition.time}
                            <br />
                            <b>Descrição: </b>
                            {solicition.description}
                          </td>

                          <td>
                            {solicition.status == 0 ? (
                              <label className="label bg-warning m-l-xs">
                                Pendente
                              </label>
                            ) : null}

                            {solicition.status == 1 ? (
                              <label className="label bg-success m-l-xs">
                                Aprovado
                              </label>
                            ) : null}

                            {solicition.status == 2 ? (
                              <label className="label bg-danger m-l-xs">
                                Recusado
                              </label>
                            ) : null}
                            {solicition.status == 3 ? (
                              <label className="label bg-danger m-l-xs">
                                {solicition.status_title}
                              </label>
                            ) : null}
                          </td>
                          <td>
                            <button
                              onClick={() =>
                                this.cancelPaymentSolicitation(solicition.id)
                              }
                              className="btn btn-danger"
                            >
                              Cancelar Solicitação de Pagamento
                            </button>
                            <button
                              onClick={() =>
                                this.erasePaymentSolicitation(solicition.id)
                              }
                              style={{ marginTop: 5 }}
                              className="btn btn-danger"
                            >
                              Excluir Solicitação de Pagamento
                            </button>
                          
                                <button
                                  onClick={() => {
                                    const win = window.open(
                                      `/#/render-cupom/${solicition.id}`,
                                      "_blank"
                                    );
                                    win.focus();
                                  }}
                                  style={{ marginTop: 5 }}
                                  className="btn btn-default"
                                >
                                  Imprimir Cupom
                                </button>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </Painel>
        </div>
      </div>
    );
  }
}

export default PaymentSolicitation;



// WEBPACK FOOTER //
// ./src/views/PaymentSolicitation/index.js